/* eslint-disable jsx-a11y/control-has-associated-label */
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';

import Image from 'Component/Image';
import Link from 'Component/Link';
import ScrollSwiper from 'Component/ScrollSwiper';
import ScrollSwiperSlide from 'Component/ScrollSwiperSlide';
import TextPlaceholder from 'Component/TextPlaceholder';
import { CategoryTreeType } from 'Type/Category.type';
import media, { CATEGORY_MEDIA } from 'Util/Media';

import { appendSlash } from '../../util/Url';

import './CategoriesSlider.style';

/** @namespace Bodypwa/Component/CategoriesSlider/Component */
export class CategoriesSliderComponent extends PureComponent {
    static propTypes = {
        category: CategoryTreeType.isRequired,
        isSlider: PropTypes.bool,
        isLoading: PropTypes.bool.isRequired
    };

    static defaultProps = {
        isSlider: false
    };

    sliderRef = createRef();

    sliderContianerRef = createRef();

    slideNext = () => {
        this.sliderRef.current.scroll({
            top: 0,
            left: this.sliderRef.current.scrollLeft + this.sliderRef.current.offsetWidth,
            behavior: 'smooth'
        });
    };

    slidePrev = () => {
        this.sliderRef.current.scroll({
            top: 0,
            left: this.sliderRef.current.scrollLeft - this.sliderRef.current.offsetWidth,
            behavior: 'smooth'
        });
    };

    renderSlider = () => {
        const {
            category: { children }, isSlider, isLoading
        } = this.props;

        if ((typeof children === 'undefined' || children.length === 0) && isLoading) {
            return (
                <ScrollSwiper>
                    { this.renderPlaceholders() }
                </ScrollSwiper>
            );
        }

        if (isSlider) {
            return (
                <ScrollSwiper>
                    { children.map(this.renderSlide) }
                </ScrollSwiper>
            );
        }

        return (
            <div block="SubCategories" elem="Container">
                { children.map(this.renderWithOutSlider) }
            </div>
        );
    };

    renderPlaceholders = () => Array.from(
        { length: 6 },
        (_, i) => this.renderSlide({}, i)
    );

    renderWithOutSlider = (category, i) => {
        const {
            name,
            thumbnail,
            url_path
        } = category;

        return (
                <Link
                  to={ url_path }
                  key={ url_path }
                  block="Subcategories"
                  elem="Button"
                  mods={ { type: 'category' } }
                  aria-label={ name }
                >

                    <figure
                      block="CategoriesSlider"
                      elem="Figure"
                      key={ `CategoriesSlider${i}` }
                    >
                        <Image
                          mix={ { block: 'CategoriesSlider', elem: 'FigureImage' } }
                          ratio="custom"
                          src={ media(thumbnail, CATEGORY_MEDIA) }
                        />
                        <div block="CategoriesSlider-SlideOverlay"> </div>
                        <div block="CategoriesSlider-Name">{ name }</div>
                    </figure>
                </Link>
        );
    };

    renderSlide = (category, i) => {
        const {
            name,
            thumbnail,
            url_path
        } = category;

        if (!thumbnail) {
            return (
                <ScrollSwiperSlide>
                    <p
                      key={ `button-${ i}` }
                      block="Header"
                      elem="Button"
                      mods={ { type: 'category' } }
                      aria-label="loader"
                    >
                        <figure
                          block="CategoriesSlider"
                          elem="Figure"
                          key={ i }
                        >
                            <Image
                              mix={ { block: 'CategoriesSlider', elem: 'FigureImage' } }
                              ratio="custom"
                              src
                            />
                            <div block="SlideOverlay"> </div>
                            <TextPlaceholder length="half" align="center" />
                        </figure>
                    </p>
                </ScrollSwiperSlide>
            );
        }

        return (
            <ScrollSwiperSlide>
                <Link
                  to={ appendSlash(url_path) }
                  key={ appendSlash(url_path) }
                  block="Header"
                  elem="Button"
                  mods={ { type: 'category' } }
                  aria-label={ name }
                >
                    <figure
                      block="CategoriesSlider"
                      elem="Figure"
                      key={ i }
                    >
                        <Image
                          mix={ { block: 'CategoriesSlider', elem: 'FigureImage' } }
                          ratio="custom"
                          src={ media(thumbnail, CATEGORY_MEDIA) }
                        />
                        <div block="SlideOverlay"> </div>
                        <h3 block="CategoriesSlider-Name">{ name }</h3>
                    </figure>
                </Link>
            </ScrollSwiperSlide>
        );
    };

    render() {
        return (
            <>
                { this.renderSlider() }
            </>
        );
    }
}

export default CategoriesSliderComponent;
